import { Box, useTheme } from '@mui/material';
import React from 'react';

type LogoType = {
    type?: 'light' | 'dark';
    size?: 'small' | 'medium' | 'large';
};

const logos = {
    light: '/images/logo-purple.svg',
    dark: '/images/logo-white.svg',
};

const compactLogos = {
    light: '/images/logo-icon-purple.png',
    dark: '/images/logo-icon-white.png',
};

const sizes = {
    small: '40px',
    medium: '150px',
    large: '100%',
};

export const Logo: React.FC<LogoType> = (props): JSX.Element => {
    const theme = useTheme();

    const type = props.type ? props.type : theme?.palette.mode || 'light';
    const size = props.size || 'medium';
    const compact = size === 'small';
    const src = compact ? compactLogos[type] : logos[type];
    const width = sizes[size];

    return (
        <Box
            sx={{
                width,
                height: compact ? 40 : 'auto',
                minWidth: compact ? 40 : undefined,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'visible',
                lineHeight: 0,
            }}>
            <Box
                component="img"
                src={src}
                alt="logo"
                sx={{
                    display: 'block',
                    width: compact ? 40 : '100%',
                    height: compact ? 40 : 'auto',
                    maxWidth: '100%',
                    objectFit: 'contain',
                }}
            />
        </Box>
    );
};
